// extracted by mini-css-extract-plugin
export default {"app":"app--nCU5G"};